import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_o5/_o5-required/tech-ops/test-run/_test-run')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'e2e-test-run-list',
        label: 'E2E Test Runs',
        to: '/tech-ops/test-run',
      }),
    }) satisfies AggregateBreadcrumb,
});
